import type { LabFeatureFlagKey } from '@brightlocal/labs-sdk';

/**
 * Central registry of PostHog feature flag keys used in the app.
 * Using a constant prevents magic strings and makes flags greppable.
 */
export const FEATURE_FLAGS = {
  REVIEW_TRACKER_ALLOWED: 'review-tracker-allowed',
  REVIEW_MANAGER_ALLOWED: 'review-manager-allowed',
  LRT_ALLOWED: 'lrt-allowed',
  GBP_INSIGHTS_ALLOWED: 'gbp-insights-allowed',
  ACCOUNT_SETTINGS_ALLOWED: 'account-settings-allowed',
  ONBOARDING_BUTTON_AA_EXPERIMENT: 'onboarding-button-aa-experiment',
  DARK_MODE_ALLOWED: 'dark-mode-allowed',
  LSG_GOOGLE_MAPS_RESULTS_ALLOWED: 'lsg-google-maps-results-allowed',
  LSG_SETTINGS_ALLOWED: 'lsg-settings-allowed',
  /** Kill switch for the whole Labs section; each lab adds its own `labs-<id>-allowed` flag. */
  LABS_ALLOWED: 'labs-allowed'
} as const;

/** A flag from the registry, or a per-lab flag declared in a lab manifest. */
export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS] | LabFeatureFlagKey;
